let fileMap: { [key: string]: string } = {};
let staticStylesMap: { [key: string]: string } = {};
const assetURL = process.env.ASSET_URL || "/";

try {
    // tslint:disable-next-line:no-var-requires
    staticStylesMap = require("../../public/staticWidgetStyles.json");
} catch (e) {
    // don't care
}

// This should not happen on a dev's local machine.
if (process.env.ENV) {
    try {
        // tslint:disable-next-line:no-var-requires
        fileMap = require("../../public/hashFileMap.json");
    } catch (e) {
        // this is fine...
    }
}

/**
 * Use this function to link to a static file in the /public directory.
 * This will automatically point to S3 on prod and honors hashed static files as well.
 */
export function resolveStaticFile(filename: string) {
    if (typeof fileMap[filename] === "undefined") {
        return `${assetURL}${filename}`;
    }

    return `${assetURL}${fileMap[filename]}`;
}

export function resolveStaticWidgetFile(widgetName: string) {
    if (staticStylesMap[widgetName]) {
        return resolveStaticFile(staticStylesMap[widgetName]);
    }
    return "";
}
